import React from "react";
import PropTypes from "prop-types";
import { Typography, Grid, CardContent, CardHeader, CardActions, Avatar, Box } from "@mui/material";
import { FaStethoscope } from "react-icons/fa";
import GoogleMapReact from "google-map-react";

import CallVipLink from "../../layout/CallVipLink";
import { PatientData } from "../../Contexts";
import * as CONST from "../../Constants";
import PcpLocationItem from "./PcpLocationItem";
import MapMarker from "./MapMarker";

const propTypes = {
  actions: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};

ElectedPcp.prototype = propTypes;

export default function ElectedPcp(props) {
  const patient = React.useContext(PatientData);
  const [location, setLocation] = React.useState(null);

  React.useEffect(() => {
    if (!location && patient.pcp.latitude) {
      setLocation({
        lat: parseFloat(patient.pcp.latitude),
        lng: parseFloat(patient.pcp.longitude),
      });
    }
  }, []);

  return (
    <Grid
      container
      direction="row"
      justifyContent="flex-start"
      alignItems="stretch"
      sx={{ pl: 1, pr: 1, pb: 2 }}
    >
      <Grid item xs={12}>
        <Typography variant="overline" pl={2} mt={1}>
          Your PCP
        </Typography>
      </Grid>
      <Grid item xs={12} md={7} pr={1} pl={1}>
        <CardHeader
          sx={{ color: "#0a3a56", px: 0, pb: 2 }}
          avatar={
            <Avatar sx={{ color: "#0a3a56" }}>
              <FaStethoscope />
            </Avatar>
          }
          title={patient.pcp.full_name ? patient.pcp.full_name : patient.pcp.name}
        />
        <Box ml={1} mr={2}>
          <PcpLocationItem
            practice={{
              ...patient.pcp,
              address: patient.elected_pcp_practice ? patient.elected_pcp_practice.address : patient.pcp.address,
              pcp_group: patient.pcp.pcp_group,
              name: patient.pcp.practice,
              date_hours_available: patient.pcp.date_hours_available,
            }}
          />
          <Typography mt={1}>
            {CONST.CONTACT_PCP}
            <CallVipLink />
          </Typography>
          <CardActions
            disableSpacing
            sx={{
              mr: 2,
              width: "-webkit-fill-available",
              py: 1,
              px: 0,
            }}
          >
            <button onClick={(e) => props.actions()} disabled={props.disabled}>
              {CONST.CHANGE_PCP}
            </button>
          </CardActions>
        </Box>
      </Grid>
      <Grid item xs={12} md={5} py={1}>
        <CardContent className="elected">
          {location && (
            <>
              <Box
                width="100%"
                sx={{
                  height: { xs: "25vh", sm: "30vh" },
                }}
              >
                <GoogleMapReact
                  defaultCenter={{ ...location }}
                  defaultZoom={14}
                  bootstrapURLKeys={{ key: `${patient.google_maps_api_key}` }}
                  yesIWantToUseGoogleMapApiInternals
                >
                  {location && (
                    <MapMarker
                      selectable={false}
                      showPcps={false}
                      selectHandler
                      lat={location.lat}
                      lng={location.lng}
                      practice={patient.pcp}
                    />
                  )}
                </GoogleMapReact>
              </Box>
            </>
          )}
        </CardContent>{" "}
      </Grid>
    </Grid>
  );
}
